import { Skeleton as MuiSkeleton, SkeletonProps } from "@mui/material";

interface Props extends SkeletonProps {}

export const Skeleton = (props: Props) => {
  return <MuiSkeleton {...props}>{props.children}</MuiSkeleton>;
};
